/* eslint-disable max-len */
import { laptopMediumMax, laptopMediumMin } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { DefaultTheme, css } from 'styled-components';
import { Text } from '../typography';

const svgPath = (theme: DefaultTheme) =>
  `"data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512' style='display: inline-block; overflow: visible;'%3E%3Cpath fill='%23${theme.primary.replace(
    '#',
    '',
  )}' d='M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z'%3E%3C/path%3E%3C/svg%3E"`;

export const SideBar = styled.div`
  flex-basis: 350px;
  background-color: #f8f8f8;
  border-bottom-right-radius: 8px;

  /* if changing media query, also update SideBarContainer 
  & ArticleMainContentContainer in ArticleContentContainer.style */
  @media (${laptopMediumMin}) {
    flex-basis: 350px;
    border-top-right-radius: 8px;
  }

  @media (${laptopMediumMax}) {
    border-bottom-left-radius: 8px;
  }
`;

export const SideBarContainer = styled.div`
  padding: 25px;
`;

export const ArticleSectionContainer = styled.div<{ noBorder?: boolean }>`
  padding: ${({ noBorder }) => (noBorder ? 0 : 25)}px 0 25px 0;
  border-top: ${({ noBorder }) => (noBorder ? 0 : 1)}px solid ${({ theme }) => theme.backgroundLight};
`;

export const ArticleSectionTitle = styled(Text)`
  font-weight: bold;
  line-height: 1.5;
  font-size: 20px;
`;

export const ArticleNavTitle = styled.span<{ lastWord?: boolean }>`
  display: inline;
  vertical-align: middle;
  position: relative;

  ${({ lastWord, theme }) =>
    lastWord
      ? css`
          &:after {
            content: '';
            background: transparent url(${svgPath(theme)}) no-repeat;
            display: inline-block;
            position: absolute;
            width: 0.8em;
            height: 0.8em;
            bottom: 4px;
            margin-left: 5px;
          }
        `
      : ''}
`;

export const ArticleNavLink = styled(Link)`
  margin-top: 20px;
  display: inline-block;
  color: ${({ theme }) => theme.textDark};
  transition: 300ms all;

  svg {
    margin-left: 4px;
    color: ${({ theme }) => theme.primary};
    display: inline-block;
    vertical-align: middle;
    font-size: 0.8em;
    margin-top: 3px;
  }

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ShareLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
  flex-wrap: wrap;
`;

export const ShareLink = styled.a`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryTranslucent};
  padding: 10px;
  border-radius: 100%;

  svg {
    font-size: 24px;
    width: 24px;
    color: ${({ theme }) => theme.textDark};
    transition: color linear 150ms;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
`;
